import $ from "jquery";
import Game from "./game";

const game = new Game($('.container'));
